import '@polymer/polymer/lib/elements/custom-style.js';
import '@polymer/polymer/lib/elements/dom-module.js';

const $_documentContainer = document.createElement('custom-style');
$_documentContainer.setAttribute('title', 'nirvana-ds-typography');

$_documentContainer.innerHTML = `
  <style>
    html {
      /* TYPOGRAPHY */
      --font-family: 'Montserrat', sans-serif;
      --font-family-secondary: 'IBMPlex', 'IBM Plex Sans', sans-serif;
      --font-family-secondary-mono: 'IBMPlex Mono', 'IBM Plex Mono', sans-serif;

      --dynamic-font-size-changer: 0px;
      --dynamic-small-font-size-changer: 0px;

      /* USE FOLLOWING VARIABLES FOR FONT-SIZE */
      /* EXAMPLE : IF YOU WANT A TEXT WITH FONT-SIZE=15PX */
      /* THEN USE var(--body-size-xlarge) VARIABLE */
      /* font-size: var(--body-size-xlarge); */

      --display-1-size: calc(20px + var(--dynamic-font-size-changer));
      --display-2-size: calc(16px + var(--dynamic-font-size-changer));
      --display-large-size: calc(50px + var(--dynamic-font-size-changer));

      --body-size-xxsmall: calc(8px + var(--dynamic-small-font-size-changer));
      --body-size-xsmall: calc(10px + var(--dynamic-small-font-size-changer));
      --body-size-small: calc(11px + var(--dynamic-small-font-size-changer));
      --body-size: calc(12px + var(--dynamic-small-font-size-changer));
      --body-size-medium: calc(13px + var(--dynamic-small-font-size-changer));
      --body-size-large: calc(14px + var(--dynamic-font-size-changer));
      --body-size-xlarge: calc(15px + var(--dynamic-font-size-changer));
      --body-size-xxlarge: calc(16px + var(--dynamic-font-size-changer));

      --header-font-size: calc(20px + var(--dynamic-font-size-changer));
      --header-font-size-large: calc(24px + var(--dynamic-font-size-changer));
      --header-font-size-xlarge: calc(40px + var(--dynamic-font-size-changer));

      --card-section-title: calc(22px + var(--dynamic-font-size-changer));

      --general-donut-chart-value: calc(22px + var(--dynamic-font-size-changer));
      --general-donut-chart-label: calc(18px + var(--dynamic-font-size-changer));

      --button-font-size: var(--body-size-large);
      --small-button-font-size: var(--body-size-small);

      --tooltip-font-size: 14px;

      --dialog-title-font-size: calc(18px + var(--dynamic-font-size-changer));
      --dialog-font-size: var(--body-size-large);

      --incident-counter-font-size: calc(36px + var(--dynamic-font-size-changer));
    }
  </style>
`;

document.head.appendChild($_documentContainer);
